import React from 'react';
import Icon from 'flow/components/ui-components/Icon';
import { twMerge } from 'tailwind-merge';

interface Props {
    onClick: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        text: string,
    ) => void;
    text: string;
    isLoading?: boolean;
    isSelected?: boolean;
    disabled?: boolean;
}

const SuggestedTag = ({
    onClick,
    text,
    isLoading,
    isSelected,
    disabled,
}: Props) => {
    return (
        // The whole tag is the control, so it is the button: a div with an
        // onClick cannot be focused, which left the inner icon button as the
        // only way to reach this from a keyboard -- it had no handler of its
        // own, and worked only because the click bubbled out to the div.
        // Promoting the tag and demoting the icon keeps that path open with
        // one control instead of two, named by the tag's own text.
        <button
            type="button"
            disabled={disabled}
            className={twMerge(
                'darken-5 hover:darken-10 flex h-7 max-w-xs items-center justify-evenly rounded-md ps-2 pe-1 text-sm text-black',
                isSelected ? 'bg-gray-300' : 'bg-gray-100 dark:bg-gray-200',
                disabled ? 'cursor-default' : 'cursor-pointer',
            )}
            onClick={(event) => onClick(event, text)}
        >
            {text}
            <span
                className="hover:darken-10 ms-1 flex size-5 items-center justify-center rounded-xl"
                key={text}
            >
                <Icon
                    size="0.875rem"
                    className={twMerge(
                        'text-gray-800',
                        disabled ? 'cursor-default' : 'cursor-pointer',
                        isLoading ? 'animate-spin' : null,
                    )}
                    iconKey={isSelected ? 'close' : 'add'}
                />
            </span>
        </button>
    );
};

export default SuggestedTag;
